<template>
  <nav class="mt-2">
    <ul
      class="nav nav-pills nav-sidebar flex-column"
      data-widget="treeview"
      role="menu"
      data-accordion="false"
    >
      <li
        class="nav-item"
        @click="expa($event)"
        v-for="(item, index) in nodes"
        :key="item.title"
      >
        <tree-node :showMenu="showMenu" :index="index" :node="item"></tree-node>
      </li>
    </ul>
  </nav>
</template>

<script>
import TreeNode from "./TreeNode";

export default {
  name: "TreeView",
  components: { TreeNode },
  props: {
    nodes: Array,
    showMenu: Boolean
  },
  data() {
    return {
      expand: false
    };
  },
  methods: {
    expa(e) {
      if (e.target.innerText && e.target.innerText.trim() === "Администрирование") {
        this.expand = !this.expand;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.nav-pills {
  display: flex;
  flex-direction: column;

  gap: 8px;
  .nav-item {
    position: relative;
    max-width: 48px;
    svg {
      position: absolute;
      left: 220px;
      top: 14px;
    }
  }
  .expandedOpen {
    transform: rotate(180deg);
  }
  .nav-link {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.2;
    color: $gray-medium;

    &.router-link-active {
      color: $blue-light;
    }
  }
}
</style>
